import { combineReducers } from 'redux'
import selectedCustomer from './selectedCustomer'
import search from './search'

export default combineReducers({
  selectedCustomer,
  search,
})



// WEBPACK FOOTER //
// ./src/stores/ui/index.js